import React from 'react'
import { I18n } from '@front/volcanion'

import { Typography, Box, Grid } from '@mui/material'
import { TextField, ModelMenuSelectorField, OptionSelectorField, DateTimeField } from '@front/squirtle'

const Title = props =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('user.search')} </Typography>
  </Grid>

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField name={'customerinfo.client_number'} label={I18n.t('user.number')} />
    </Grid>
    <Grid size="grow">
      <TextField name={'auth.gsm'} label={I18n.t('phone.label', { count: 1 })} />
    </Grid>
    <Grid size={3}>
      <TextField name='auth.email' label={I18n.t('email.label', { count: 1 })} />
    </Grid>
    <Grid size={1}>
      <ModelMenuSelectorField
        name={'auth.application'}
        label={I18n.t('application.label', { count: 1 })}
        model_name={'application'}
        loadOnMount
        searchMode='search'
        labelKeys={['name']}
        config={{ sort: ['display_index ASC'] }}
        noneLabel={I18n.t('all_secondary')}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'customerinfo.name'}
        label={I18n.t('designation')}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'info.last_name'}
        label={I18n.t('name.label', { count: 1 })}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'info.first_name'}
        label={I18n.t('name.first_name', { count: 1 })}
      />
    </Grid>
  </Grid>

const Row2 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='commercial_formula'
        label={I18n.t('commercial_formula.label', { count: 1 })}
        model_name='commercialformula'
        labelKeys={['name']}
        searchMode={'search'}
        loadOnMount
        multiple
        clearOnEmpty
      />
    </Grid>
    <Grid size={3}>
      <DateTimeField
        name='createdAt.start'
        dateProps={{
          label: I18n.t('date.search'),
          inputFormat: 'DD/MM/YYYY'
        }}
        timeProps={{
          label: I18n.t('prefix.at'),
          minTime: null
        }}
        default_time='00:00'
      />
    </Grid>
    <Grid size={3}>
      <DateTimeField
        name='createdAt.end'
        dateProps={{
          label: I18n.t('prefix.to'),
          inputFormat: 'DD/MM/YYYY'
        }}
        timeProps={{
          label: I18n.t('prefix.at'),
          minTime: null
        }}
        default_time='23:59'
      />
    </Grid>
  </Grid>

const Row3 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <OptionSelectorField
        name={'status'}
        label={I18n.t('status.label', { count: 1 })}
        valueType={'checkbox'}
        multiple
        options={[
          { label: I18n.t('status.active'), color: 'green', value: 'active' },
          { label: I18n.t('status.suspended'), color: 'orange', value: 'suspended' },
          { label: I18n.t('status.deleted'), color: 'red', value: 'deleted' },
        ]}
        getOptionLabelProps={({ color }) => ({ slotProps: { typography: { color } } })}
      />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 />
      <Row2 />
      <Row3 />
    </Grid>
  </Box>

export default React.memo(SearchForm)
